<div class="sticky">
  <button (click)="onClick()">Get help and tips</button>
</div>

